<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
            <page-title title="How to Use PayNow to Make Payment" />
            <div
              class="ml-2"
              :style="textColor"
            >
              <p>Thank you for your order! Your total is <strong>{{ order ? order.payable : activeOrder.payable }}</strong></p>
              <p>Please proceed to make payment via PayNow, to confirm your order.</p>
              <p>1) You can scan this QR or enter our UEN Number/Phone Number: <strong>{{ gemsSetting.UEN }}</strong></p>
              <p>2) Click "Confirm / OK / Send Payment" etc to complete the payment</p>
              <img :src="link" title="PayNow" @load="hideLoading" />
              <p>We will contact you shortly via WhatsApp for order confirmation. 
                <span v-if="restaurantContact">If we do not get back to you within 15 minutes, please reach us at <strong>{{ restaurantContact }}</strong></span>
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-footer
      fixed
      app
      inset
      :height="theme.footer_height"
      :color="theme.footer_bg_color"
    >
      <template>
        <v-btn
          block
          dark
          large
          class="btn"
          :color="theme.btn_color_primary"
          @click="closeInstruction"
        >
          <v-layout row>
            <v-flex
              xs12
              class="text-xs-center"
            >
              {{ $t('close') }}
            </v-flex>
          </v-layout>
        </v-btn>
      </template>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import generatePayNowStr from '~/paynow'
import moment from 'moment'

export default {
  name: 'paynow-instruction',
  metaInfo () {
    return { title: "PayNow Instruction" }
  },
  components: {
    'page-title': PageTitle,
  },
  data: () => ({
    order: null
  }),
  computed: {
    ...mapGetters('auth',[
      'user'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    ...mapGetters('config', [
      'config', 'theme', 'rid', 'gid', 'mode', 'gemsSetting', 'restaurantContact'
    ]),
    ...mapGetters('cart', [
      'cart', 'cartAmount', 'cartQty'
    ]),
    ...mapGetters('order', [
      'activeOrder', 'orders'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    opts () {
      let opts
      opts = {
        uen: (this.gemsSetting.UEN.length === 8 && !isNaN(this.gemsSetting.UEN)) ? '+65'+this.gemsSetting.UEN : this.gemsSetting.UEN,
        type: (this.gemsSetting.UEN.length === 8 && !isNaN(this.gemsSetting.UEN)) ? '0' : '2',
        editable: 0, // 0 => price not editable, 1 => price editable
        expiry: moment().add(1,'day').format('YYYYMMDD'), // temporary set as tomorrow
        amount: this.order ? this.order.payments_topay : this.activeOrder.payments_topay,
        refNumber: moment().format('YYYYMMDDHHmmss') + ' ' + this.config.name,
        companyName: this.config.full_name
      }
      return opts
    },
    qr () {
      let str = generatePayNowStr(this.opts)
      let str2 = str.replace('+', '%2B')
      return str2
    },
    link () {
      return "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=" + this.qr
    },
    textColor () {
      return {
        color: this.theme.orders_name_color
      }
    },
  },
  methods: {
    hideLoading () {
      this.$bus.$emit('showFullLoading', false)
    },
    closeInstruction () {
      if (this.orders.find(o => parseInt(o.id) === parseInt(this.order.id))) {
        this.$router.push({ name: 'order2', params: { id: this.order.id.toString() }})
      } else {
        this.$router.push({ name: 'orders' })
      }
    }
  },
  mounted () {
    if (!this.activeOrder) {
      this.$router.push({ name: 'orders' })
    }
    this.$bus.$emit('showFullLoading', true)
    // Shallow clone before resetting
    this.order = Object.assign({}, this.activeOrder)
    this.$store.dispatch('order/resetOrder')
  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/paynow_instruction.vue